import { useDispatch, useStore } from 'react-redux';
import { useMemo } from 'react';
import { IRegistrationServiceStorage } from '../lib';
import { ReducerStateShape, registrationStateSelector, registrationTokenSelector, slice } from './slice';

export const useRegistrationStorage = (): IRegistrationServiceStorage => {
  const dispatch = useDispatch();
  const store = useStore<ReducerStateShape>();
  return useMemo(
    () => ({
      getState: () => registrationStateSelector(store.getState()),
      getToken: () => registrationTokenSelector(store.getState()),
      setState: (state) => dispatch(slice.actions.setState(state)),
      setToken: (token) => dispatch(slice.actions.setToken(token)),
      clear: () => dispatch(slice.actions.clear()),
    }),
    [store, dispatch],
  );
};
